import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'frameworkSVG',
}) => (
  <svg
    viewBox="0 0 288 267.5"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    >
    <g>
      <polygon points="226.4,43 226.4,216.1 53.2,216.1 53.2,237.8 248,237.8 248,43 	" />
      <path d="M213.1,29.8H40v173.1h173.1V29.8z M191.5,73H60.3V50.6h131.2V73z" />
    </g>
  </svg>
);

export default SVG;
